import { useEffect } from "react";
import Lenis from "lenis";
import { useContent } from "@/context/AppContext";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Summary from "@/components/Summary";
import KpiBento from "@/components/KpiBento";
import Expertise from "@/components/Expertise";
import CaseStudies from "@/components/CaseStudies";
import Experience from "@/components/Experience";
import Certifications from "@/components/Certifications";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

export default function Portfolio() {
  const { content } = useContent();

  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return undefined;
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let raf = requestAnimationFrame(function loop(time) {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    });
    const onClick = (e) => {
      const anchor = e.target.closest && e.target.closest('a[href^="#"]');
      if (!anchor) return;
      const href = anchor.getAttribute("href");
      if (href && href.length > 1) {
        const el = document.querySelector(href);
        if (el) {
          e.preventDefault();
          lenis.scrollTo(el, { offset: -76 });
        }
      }
    };
    document.addEventListener("click", onClick);
    return () => {
      document.removeEventListener("click", onClick);
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  if (!content) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-offwhite">
        <div className="font-mono text-sm tracking-widest text-slate-400" data-testid="portfolio-loading">
          RYAN HIDAYAT — LOADING
        </div>
      </div>
    );
  }

  return (
    <div className="portfolio-root">
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <Summary />
        <KpiBento />
        <Expertise />
        <CaseStudies />
        <Experience />
        <Certifications />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
